<template>
  <div class="ncdc-page-wrapper">
    <the-header ref="theHeader" />
    <div class="container-fluid px-3 px-md-4 py-3">
      <!-- Attribution & Source Notice Banner -->
      <div class="ncdc-notice-banner mb-3">
        <div class="notice-left">
          <div class="notice-icon-container">
            <b-icon icon="info-circle-fill" class="notice-icon"></b-icon>
          </div>
          <div class="notice-body">
            <div class="d-flex align-items-center flex-wrap mb-1">
              <span class="notice-kicker mr-2">External Visualization</span>
              <span class="notice-source-tag">Nigeria Centre for Disease Control (NCDC)</span>
            </div>
            <p class="notice-description mb-0">
              <strong>Notice:</strong> This Disease Surveillance visualization is imported directly from the official <strong>NCDC website</strong> and is maintained and managed by them.
            </p>
          </div>
        </div>
        <div class="notice-right mt-2 mt-md-0">
          <a
            href="https://ncdc.gov.ng"
            target="_blank"
            rel="noopener noreferrer"
            class="notice-action-btn"
          >
            <span>Visit NCDC</span>
            <b-icon icon="box-arrow-up-right" font-scale="0.8" class="ml-1"></b-icon>
          </a>
        </div>
      </div>

      <div class="tab-content">
        <div class="d-flex justify-content-center" v-if="currentTab === 'Dashboard'">
          <b-embed
            type="iframe"
            aspect="16by9"
            :src="url"
            :width="width"
            :height="height"
            class="viz-embed shadow-sm"
          ></b-embed>
        </div>
      </div>
    </div>
    <the-footer />
  </div>
</template>

<script>
import theHeader from '../../about/layout/theHeader.vue';
import theFooter from '../../about/layout/theFooter.vue';

export default {
  name: 'NCDC',
  components: {
    theHeader,
    theFooter,
  },
  data() {
    return {
      currentTab: 'Dashboard',
      url: 'https://public.tableau.com/views/NationalDiseaseDashboardNCDC2022/Dashboard1?:language=en-US&:embed=y&:sid=&:redirect=auth&:embed_code_version=3&:loadOrderID=0&:display_count=y&publish=yes&:origin=viz_share_link:showVizHome=no&:embed=true',
      width: '100%',
      showComing: true,
      currentTitle: ' Disease Surveillance Dashboard (NCDC)',
    };
  },
  methods: {
    setTab(tab) {
      this.currentTab = tab;
      this.currentTitle = tab;
    },
  },
};
</script>

<style scoped>
.ncdc-page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8faf9;
  font-family: 'Work Sans', sans-serif;
}

.ncdc-notice-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #ffffff 0%, #f0f8f5 100%);
  border: 1px solid rgba(0, 125, 83, 0.2);
  border-left: 5px solid #007d53;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(10, 35, 25, 0.05);
}

.notice-left {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.notice-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: rgba(0, 125, 83, 0.12);
  color: #007d53;
  margin-top: 2px;
}

.notice-icon {
  font-size: 1.3rem;
}

.notice-body {
  flex: 1;
}

.notice-kicker {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #007d53;
}

.notice-source-tag {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
  background-color: #e6f4ef;
  color: #17533f;
}

.notice-description {
  font-size: 0.98rem;
  line-height: 1.55;
  color: #2c3e50;
}

.notice-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #007d53;
  background: #ffffff;
  border: 1px solid rgba(0, 125, 83, 0.3);
  border-radius: 8px;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.notice-action-btn:hover {
  background-color: #007d53;
  color: #ffffff;
  border-color: #007d53;
  text-decoration: none;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 125, 83, 0.2);
}

.tab-content {
  width: 100%;
}

.viz-embed {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

@media (max-width: 768px) {
  .ncdc-notice-banner {
    flex-direction: column;
    align-items: flex-start;
  }

  .notice-right {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
